import * as actionTypes from '../Actions/actionTypes';

const defaultState = {
	apiFlag: true,
	Data: [],
	selectSupplier: [],
	selectCategory: []
};

export default function setAddInventoryReducer(
	state = defaultState,
	action = {}
) {
	switch (action.type) {
		case actionTypes.ADD_INVENTORY_ITEM:
			return { ...state };

		case actionTypes.SET_ALL_CATEGORY_NAME_INTO_ADD_INVENTORY_ITEM_SELECT:
			return {
				...state,
				selectCategory: [...action.payload]
			};
		case actionTypes.SET_ALL_SUPPLIER_NAME_INTO_ADD_INVENTORY_ITEM_SELECT:
			return {
				...state,
				selectSupplier: [...action.payload]
			};
		case actionTypes.GET_ALL_INVENTORY:
			return {
				...state,
				Data: [...action.payload]
			};
		case actionTypes.SET_LOADER_FLAG_INVENTORY_ADD:
			return {
				...state,
				apiFlag: action.payload
			};
		case actionTypes.DELETE_INVENTORY_ITEM:
			let filterCandidateReqList = state.Data.filter(
				filterOBJ => filterOBJ.id !== action.payload
			);

			return {
				...state,
				Data: filterCandidateReqList
			};
		case actionTypes.EDIT_INVENTORY_ITEM_RECORD:
			var adminData = [...state.Data];
			var index = adminData.findIndex(obj => obj.id === action.payload.id);

			adminData[index].name = action.payload.name;
			adminData[index].price = action.payload.price;
			adminData[index].type = action.payload.type;
			adminData[index].currentStock = action.payload.currentStock;
			adminData[index].t1.name = action.payload.supplierName;
			adminData[index].t3.name = action.payload.categoryName;
			return {
				...state,
				Data: [...adminData]
			};
		default:
			return state;
	}
}
